import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Router } from '@angular/router';

import { Warenkorb } from '../../../store/models/warenkorb';

import { OAuthService } from 'angular-oauth2-oidc';

import { AuthService } from 'src/app/modules/auth/_services/auth.service';



import { Webshops } from '../../../store/models/webshops';
import { Login1Component } from '../../logins/login1/login1.component';
import { NavService } from '../../nav/shared/nav.service';
import { WarenkorbsService } from '../../warenkorbs/shared/warenkorbs.service';
import { LayoutUtilsService } from 'src/app/core/layout-utils.service';

@Component({
    selector: 'kkis-app-webshop-top-section1',
    templateUrl: './top-section1.component.html',
    styleUrls: ['./top-section1.component.scss']
})
export class TopSection1Component implements OnInit {

    // INPUT
    @Input()
    numberWarenkorbItems: number = 0;

    // User
    loggedInUser: Webshops.ILoggedInUser;
    loggedInUserName: string;

    // Warenkorb
    warenkorb: Warenkorb.IWarenkorbDto;    

    // Settings
    useRememberMe: boolean = false;
    allowNewAccount: boolean = false;

    // Dialog
    dialogWidth: string;
    dialogHeight: string;

    // Search
    search: string = "";

    // Utils
    isLoading: boolean = false;
    isSubmitted: boolean = false;
    isLoggedIn: boolean = false;

    constructor(
        private router: Router,
        private layoutUtilsService: LayoutUtilsService,
        public dialog: MatDialog,
        private navService: NavService,
        private authService:AuthService,
        private oAuthService:OAuthService,
        private warenkorbsService:WarenkorbsService
    ) {

        
     }

    ngOnInit(): void {

        this.authService.isAuthenticated$.subscribe(x => {
            this.isLoggedIn=x;
        });

        this.authService.currentUser$.subscribe(x => {
            this.loggedInUser = x;
            if(this.loggedInUser) {
                this.loggedInUserName = this.loggedInUser.benutzernameFull;

                this.warenkorbsService.getForCustomer().subscribe(res => {
                    if (res) {
                        this.warenkorb = res;
                        this.numberWarenkorbItems = res.warenkorbPositionen.length;
                    }
                });
            }
        });      

        // if(this.oAuthService.getAccessToken())
        // {
        //     this.isLoggedIn=true;
        // }

        // Define basic values for Dialogs
        var w = 1;//this.layoutUtilsService.getBootstrapClass();

        switch(w) {
            case 0:
                this.dialogWidth = "95%";
                this.dialogHeight = "95%";
                break;
            case 1: {
                this.dialogWidth = "95%";
                this.dialogHeight = "95%";
                break;
            }
            case 2: {
                this.dialogWidth = "60%";
                this.dialogHeight = "40%";
                break;
            }
            case 3: {
                this.dialogWidth = "30%";
                this.dialogHeight = "40%";
                break;
            }
            default: {
                this.dialogWidth = "30%";
                this.dialogHeight = "40%";
                break;
            }
        }
        
    }

    onLogin() {
        this.isSubmitted = true;
        this.isLoading = true;

        //this.oAuthService.initCodeFlow();
        this.authService.login();
        return;

        // const dialogRef = this.dialog.open(Login1Component, {
        //     width: this.dialogWidth,
        //     autoFocus: true,
        // });

        // dialogRef.afterClosed().subscribe(res => {

        //     if (res) {
        //         this.loggedInUser = res;
            
        //         if (this.loggedInUser.loggedIn) {
        //             this.isLoggedIn = this.loggedInUser.loggedIn;

        //             this.warenkorbsService.getForCustomer().subscribe(res => {
        //                 if (res) {
        //                     this.warenkorb = res;
        //                     this.numberWarenkorbItems = res.warenkorbPositionen.length;
        //                 }
        //             });

        //             if (this.loggedInUser.benutzernameVorname) {
        //                 this.loggedInUserName = "Hallo, " + this.loggedInUser.benutzernameVorname;
        //             } else if (this.loggedInUser.firmenname) {
        //                 this.loggedInUserName = this.loggedInUser.firmenname;
        //             }
        //         } else {
        //             this.loggedInUserName = "Anmeldung NICHT erfolgreich."
        //         }
        //     }

        //     this.isLoading = false;
        // });
    }

    onLogout() {

//        this.oAuthService.revokeTokenAndLogout();
        this.authService.logout();
        this.loggedInUser = null;
        this.isLoggedIn = false;
        this.loggedInUserName = null;
    }

    clickMenu() {
        this.navService.toggle();
    }

    onShowWarenkorb() {

        if (this.isLoggedIn) {
            this.router.navigate(['/articles'], {
                queryParams: {
                    showWarenkorb: true,
                    showAdvertise: false
                }
            });
        } else {
            const _title: string = "Anmelden";
            const _description: string = "Sie sind noch nicht angemeldet. Jetzt anmelden?";
    
            this.layoutUtilsService.qwertDialog(_title, _description, 'question', true, true, 'Anmelden').then(res => {
                if (res.dismiss) {
                    return;
                }

                this.authService.login();
                return;
            });
        }
    }

    onReload() {
        window.location.href = '/';
    }

    onSearch() {
        if (this.search) {
            this.router.navigate(['/articles'], {
                queryParams: {
                    search: this.search,
                }
            });
        } else {
            this.router.navigate(['/articles']);
        }
    }

    onShowAccount() {

        if (this.isLoggedIn) {
            this.router.navigate(['/account']); //zum Kundenkonto navigieren
        }
        
    }

}
